import { useQuery } from 'react-query'
import { useSearchParams } from 'react-router-dom'
import { showError } from '../../../../../../_metronic/helpers'
import { getEmpresaClienteById } from './_request'

/**
 * Empregador ASO das telas filhas (cargos, setores, coordenadores...), vindo do `?cliente=` da
 * URL. Em cache pela chave: título da página, filtros e tabela compartilham a mesma requisição.
 */
export const useClienteAtual = () => {
  const [searchParams] = useSearchParams()
  const idCliente = Number(searchParams.get('cliente'))

  const { data: cliente } = useQuery(
    ['empresa-cliente', idCliente],
    () => getEmpresaClienteById(idCliente),
    { enabled: Boolean(idCliente), refetchOnWindowFocus: false, onError: showError }
  )

  return cliente
}
